import { LoadablePaint } from '@confluence/loadable';

export const ADFRendererWithExtensions = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ADFRendererWithExtensions" */ '../src/ADFRendererWithExtensions.tsx'
			)
		).ADFRendererWithExtensions,
});
